// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-transfer-player__container {
    padding: 42px 80px;
}

.tournament-transfer-player__player,
.tournament-transfer-player__from-team {
    padding: var(--space) var(--space-half-quarter);
    display: flex;
    align-items: center;
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-half);
    margin-bottom: var(--space-and-half);
}

.tournament-transfer-player__title {
    margin-bottom: var(--space-half-quarter);
}

.tournament-transfer-player__player-img,
.tournament-transfer-player__from-team-img {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: var(--space-half-quarter);
    height: 38px;
    width: 38px;
}

.tournament-transfer-player__player-img span,
.tournament-transfer-player__from-team-img span,
.tournament-transfer-player__select-team-img span {
    font-size: var(--space-x2);
    border-radius: 50%;
    padding: 4px;
    color: var(--white-color);
}

.tournament-transfer-player__player-img img,
.tournament-transfer-player__from-team-img img,
.tournament-transfer-player__select-team-img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.tournament-transfer-player__select-team {
    display: flex;
    align-items: center;
}

.tournament-transfer-player__select-team-img {
    margin-right: var(--space-half-quarter);
}

.tournament-transfer-player__team-select {
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-half);
    margin-bottom: var(--space-x3);
    margin-top: var(--space-half-quarter);
}

.tournament-transfer-player_button-btn {
    float: right;
}

.tournament-transfer-player__team-selector.MuiAutocomplete-popper{
    bottom: 280px !important;
    transform: translate(30vw, -280px) !important;
    position: sticky !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-transfer-player-modal/TournamentTransferPlayerModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,kDAAkD;IAClD,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,YAAY;IACZ,WAAW;AACf;;AAEA;;;IAGI,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kDAAkD;IAClD,gCAAgC;IAChC,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;IAC7C,2BAA2B;AAC/B","sourcesContent":[".tournament-transfer-player__container {\n    padding: 42px 80px;\n}\n\n.tournament-transfer-player__player,\n.tournament-transfer-player__from-team {\n    padding: var(--space) var(--space-half-quarter);\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-half);\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament-transfer-player__title {\n    margin-bottom: var(--space-half-quarter);\n}\n\n.tournament-transfer-player__player-img,\n.tournament-transfer-player__from-team-img {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: var(--space-half-quarter);\n    height: 38px;\n    width: 38px;\n}\n\n.tournament-transfer-player__player-img span,\n.tournament-transfer-player__from-team-img span,\n.tournament-transfer-player__select-team-img span {\n    font-size: var(--space-x2);\n    border-radius: 50%;\n    padding: 4px;\n    color: var(--white-color);\n}\n\n.tournament-transfer-player__player-img img,\n.tournament-transfer-player__from-team-img img,\n.tournament-transfer-player__select-team-img img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}\n\n.tournament-transfer-player__select-team {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-transfer-player__select-team-img {\n    margin-right: var(--space-half-quarter);\n}\n\n.tournament-transfer-player__team-select {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-half);\n    margin-bottom: var(--space-x3);\n    margin-top: var(--space-half-quarter);\n}\n\n.tournament-transfer-player_button-btn {\n    float: right;\n}\n\n.tournament-transfer-player__team-selector.MuiAutocomplete-popper{\n    bottom: 280px !important;\n    transform: translate(30vw, -280px) !important;\n    position: sticky !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
